import React, { useEffect, useState } from "react";
import {
  fetchNativeFeatures,
  fetchPlatformParameters,
} from "@origin-digital/event-dispatcher";
import { useAppContext } from "../../AppContext";
import { Chat } from "./Chat";
import { BackendCrm } from "@origin-digital/platform-enums";

export const ChatController = (): JSX.Element => {
  const { isNative } = useAppContext();
  const [nativeChatSupported, setNativeChatSupported] = useState<boolean>(
    false
  );
  // Add Crm(s) that need to be supported by intercom
  const chatSupportedCrm: BackendCrm[] = [BackendCrm.LPG];

  useEffect(() => {
    // Check if chat is supported in the native app
    if (isNative) {
      const setNativeChatSupportedAsync = async () => {
        try {
          const nativeFeatures = await fetchNativeFeatures({});
          const asyncMessaging =
            nativeFeatures && nativeFeatures.features.asyncMessaging;

          const platformParams = await fetchPlatformParameters({});
          const customersBackendCrm = platformParams?.backends ?? [];

          const hasChatSupportedCrm = customersBackendCrm.some((crm) =>
            chatSupportedCrm.includes(crm)
          );

          if (!!asyncMessaging && hasChatSupportedCrm) {
            setNativeChatSupported(true);
          }
        } catch (e) {
          // Using console.log for easy debugging in the real envs.
          // No need to send to sumo.
          console.log("Error in setting native chat", e);
        }
      };
      setNativeChatSupportedAsync();
    }
  }, []);

  return <Chat isNative={isNative} nativeChatSupported={nativeChatSupported} />;
};
